export const TaskType = {
  ACTIVITY_TASK: 'activitytask',
  PROJECT: 'project',
  MAIN: 'main',
  MILESTONE: 'milestone',
  TASK: 'task'
};
